import { Button, Flex, Typography, theme, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { decodeToken } from "react-jwt";
import AuthRestAPI from '../../../restAPI/AuthRestAPI';

const { Title, Text } = Typography;

export default function VerifyMail() {
    const navigate = useNavigate();
    const {
        token: { colorPrimary, colorWarning },
    } = theme.useToken();
    const [api, contextHolder] = notification.useNotification();
    

    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    const [countdown, setCountdown] = useState(30);
    const [verificationToken, setVerificationToken] = useState("");
    const [isVerificationTokenAvailable, setIsVerificationTokenAvailable] = useState(false);
    const [decodedTokenValues, setDecodedTokenValues] = useState([]);
    const [isVerificationTokenExpire, setIsVerificationTokenExpire] = useState(false);
    const [isCheckCircleDisplay, setIsCheckCircleDisplay] = useState("none");
    const [isExclamationCircleDisplay, setIsExclamationCircleDisplay] = useState("none");

    useEffect(() => {
        if(window.location.href.includes("/verify-email?verifyToken=")){
            const parts = window.location.href.split("?verifyToken=");
            setVerificationToken(parts[1]);
            setIsVerificationTokenAvailable(true);

             //read the token values
             const decodedTokenValues = decodeToken(parts[1]);
             setDecodedTokenValues(decodedTokenValues);

             setIsVerificationTokenExpire(checkTokenExpiration(decodedTokenValues));
             if (!isVerificationTokenExpire){
                setIsCheckCircleDisplay(true);
                setIsExclamationCircleDisplay("none");
             }
             else{
                setIsExclamationCircleDisplay(true);
                setIsCheckCircleDisplay("none");
             }
        }
    });

    const checkTokenExpiration = (decodedTokenValues) => {
        const date = new Date();
        const currTime = new Date(date).getTime();

        //different between issued at with expiration
        const timeDiffernceForExpireTime = decodedTokenValues.exp - decodedTokenValues.iat;

        //different between issued at with current
        const timeDiffernceForCurrentTime = Math.trunc(currTime / 1000) - decodedTokenValues.iat;

        if (timeDiffernceForExpireTime < timeDiffernceForCurrentTime) {
            return true;
        }
        else {
            return false;
        }
    };

    const resendEmail = async () => {
        if (countdown > 0) {
            const timer = setInterval(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);

            // Clear timer on component unmount or when countdown reaches 0
            return () => clearInterval(timer);
        }
        const formData = {"email": decodedTokenValues.email};
        await AuthRestAPI.resendAccVerification(formData)
        .then((response) => {
            openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
            })
            .catch((err) => {
                if (err.response) {
                    openNotificationWithIcon('error', 'Resend email failed', `${err.response.data.message}`, 'bottomLeft');
                } else {
                    openNotificationWithIcon('error', 'Resend email failed', `${err.message}`, 'bottomLeft');
                }
            });
    }

    const activeCompanyAdmin = async () => {
        const formData = {"email": decodedTokenValues.email};
        await AuthRestAPI.activeCompanyAdmin(formData)
            .then((response) => {
                openNotificationWithIcon('success', "Successful", `Account Activated`, 'bottomLeft');
                navigate("/login")
            })
            .catch((err) => {
                if (err.response) {
                    openNotificationWithIcon('error', 'Account activation failed', `${err.response.data.message}`, 'bottomLeft');
                } else {
                    openNotificationWithIcon('error', 'Account activation failed', `${err.message}`, 'bottomLeft');
                }
            });
    }

    return (
        <Flex vertical justify='center' style={{ minHeight: 'calc(100svh - 246px)' }}>
            {/* If success */}
            <CheckCircleFilled style={{ color: colorPrimary, fontSize: 78, display: isCheckCircleDisplay }} />
            
            {/* If Not Valid */}
            <ExclamationCircleFilled style={{ color: colorWarning, fontSize: 78, display: isExclamationCircleDisplay }} />
            
            <Title hidden={isVerificationTokenExpire} level={3}> Successfully Verified Your Email</Title>
            
            <Title hidden={!isVerificationTokenExpire} level={3}> Verification Link Not Valid </Title>

            <Text hidden={isVerificationTokenExpire} type="secondary">
                Thank you for verifying your email. Now you can access our system without any interrupt
            </Text>

            <Text hidden={!isVerificationTokenExpire} type="secondary">
                Please check your inbox and click the latest link, or press try again button bellow
            </Text>

            <Flex justify='flex-start' align='center' style={{ marginTop: 30 }} gap={12}>
                <Button 
                    disabled = {!isVerificationTokenExpire && countdown < 30} 
                
                    onClick={resendEmail}
                    type="default"
                    size="large"
                >
                                    {countdown > 0 ? `Resend Email (Wait ${countdown} Seconds)` : 'Resend again'}
                </Button>
                <Button onClick={activeCompanyAdmin} disabled = {isVerificationTokenExpire} type="primary" size="large">Goto Login</Button>
            </Flex>
            {contextHolder}
        </Flex>
    );
}


